import React from "react";
import {LazyLoadComponent, LazyLoadComponentProps} from "react-lazy-load-image-component";

export const LazyComp: React.FC<LazyLoadComponentProps> = props => <LazyLoadComponent {...props} />;
